/* eslint-disable @typescript-eslint/no-unused-vars */
import { useViewport } from 'reactflow';
import { applyVueInReact } from 'vuereact-combined';

import { useReactFlow } from './functions';
import PanZoomControls from '@/views/Flow/PanZoomControls.vue';
import UpdatedBuilderFeedbackButton from '@/views/Flow/UpdatedBuilderFeedbackButton.vue';

const VuePanZoomControls = applyVueInReact(PanZoomControls);
const VueUpdatedBuilderFeedbackButton = applyVueInReact(UpdatedBuilderFeedbackButton);

export function FlowTreePanel({ runFeedbackFlow, recenter }: { runFeedbackFlow: () => void; recenter: () => void }) {
	const { fitView } = useReactFlow();
	const { zoom } = useViewport();
	return (
		<>
			<VuePanZoomControls class="fit-content" zoomScale={zoom} on={{ fitView, recenter }} />
			{/* <VueUpdatedBuilderFeedbackButton classFlowTreePanel="mt-2" on={{ click: runFeedbackFlow }} /> */}
		</>
	);
}
